import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  FormCustomField,
  FormSelect,
  FormPanel,
  getItemFactory,
  TextField,
  useFormSelector,
} from '@eas/common-web';
import { useSpecificTargets, useActivities } from '../operator-api';
import { Notice, Program, SpecificTarget } from '../../../common/models';

const getSpecificTarget = getItemFactory<SpecificTarget>();

export function NoticesFields() {
  const intl = useIntl();
  const selectedSpecificTarget = useFormSelector(
    (data: Notice) => data.parent
  );
  const [program, setProgram] = useState<Program | undefined>(
    selectedSpecificTarget?.parent
  );
  const specificTargets = useSpecificTargets();
  const activities = useActivities();

  useEffect(() => {
    setProgram(selectedSpecificTarget?.parent);

    if (
      selectedSpecificTarget == null ||
      selectedSpecificTarget.parent != null
    ) {
      return undefined;
    }

    const request = getSpecificTarget(
      '/api/ks/specific-targets',
      selectedSpecificTarget.id
    );

    request
      .json()
      .then((specificTarget: SpecificTarget) =>
        setProgram(specificTarget.parent)
      )
      .catch((error: Error) => {
        if (error.name !== 'AbortError') {
          console.error('Failed to load the specific target program', error);
        }
      });

    return request.abort;
  }, [selectedSpecificTarget]);

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="KS_O_NOTICES_FIELD_PANEL_TITLE"
          defaultMessage="Výzva"
        />
      }
    >
      <FormSelect
        name="parent"
        required
        label={
          <FormattedMessage
            id="KS_O_NOTICES_FIELD_LABEL_PARENT"
            defaultMessage="Specifický cíl"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_NOTICES_FIELD_HELP_PARENT',
          defaultMessage: ' ',
        })}
        source={specificTargets}
        tooltipMapper={(o) => o.name}
      />
      <FormCustomField
        label={
          <FormattedMessage
            id="KS_O_NOTICES_FIELD_LABEL_PROGRAM"
            defaultMessage="Program"
          />
        }
      >
        <TextField disabled value={program?.name} />
      </FormCustomField>
      <FormSelect
        name="activities"
        label={
          <FormattedMessage
            id="KS_O_NOTICES_FIELD_LABEL_ACTIVITIES"
            defaultMessage="Aktivity"
          />
        }
        helpLabel={intl.formatMessage({
          id: 'KS_O_NOTICES_FIELD_HELP_PARENT',
          defaultMessage: ' ',
        })}
        source={activities}
        tooltipMapper={(o) => o.name}
        multiple={true}
      />
    </FormPanel>
  );
}
